import useCommonResponsiveValues from 'app/hooks/useCommonResponsiveValues'
import { Box, VStack, Text, useBreakpointValue, Stack } from 'native-base'
import { BodyFontBase, BodyFontLarge } from '../../../constant/font'
import { baseVideoURL } from 'app/features/special-lecture/special-lecture-player/video-list'
import colors from 'app/colors'

const IntroSection3 = () => {
	const { containerWidth } = useCommonResponsiveValues()

	const paddingY = useBreakpointValue({
		base: '48px',
		lg: '120px',
	})

	const textSize2Props = useBreakpointValue({
		base: 'h3/800',
		lg: 'h2/900/main',
	})

	const textSize3Props = useBreakpointValue({
		base: BodyFontBase,
		lg: BodyFontLarge,
	})

	const textSize4 = useBreakpointValue({
		base: 'p_m/700',
		lg: 'h5/800',
	})

	const textSize5 = useBreakpointValue({
		base: 'p_m/700',
		lg: 'h5/700',
	})

	const flexDirection = useBreakpointValue({
		base: 'column',
		xl: 'row',
	})

	const textBoxSize = useBreakpointValue({
		base: {
			width: '344px',
			height: '165px',
		},
		lg: {
			width: '413px',
			height: '324px',
		},
	})

	return (
		<Box bgColor="singletons.white" alignItems="center" py={paddingY}>
			<VStack w={containerWidth}>
				<Text
					color="singletons.black"
					size={textSize2Props}
					textAlign="center"
				>
					1:1 공부 컨설팅 영상
				</Text>
				<Box h={{ base: '24px', lg: '32px' }} />
				<Text color="gray.700" {...textSize3Props} textAlign="center">
					수백만원 대치동 공부 컨설팅 효과 그대로!{'\n'}
					진단 결과를 바탕으로 현재를 점검하고,{' '}
					{containerWidth.endsWith('%') && '\n'}내신관리와 대입 로드맵
					설계에 있어{'\n'}
					체계적인 개인별 맞춤 학습법을 제시합니다.
				</Text>
				<Box h={{ base: '24px', lg: '60px' }} />
				<Box w={containerWidth} alignItems="center">
					<Box
						borderRadius="20px"
						maxW="1280px"
						width={{ base: '343px', lg: '100%' }}
						height={{ base: '193px', lg: '720px' }}
					>
						<video
							controls
							style={{
								maxHeight: useBreakpointValue({
									base: '193px',
									lg: '720px',
								}),
							}}
						>
							<source src={`${baseVideoURL}premium-1on1.mp4`} type='video/mp4' />
						</video>
					</Box>
				</Box>
				<Box h={{ base: '24px', lg: '60px' }} />
				<Stack flexDirection={flexDirection} alignItems="center">
					<VStack
						px={{
							base: '20px',
							lg: '24px',
						}}
						py={{
							base: '24px',
							lg: '32px',
						}}
						w={textBoxSize.width}
						h={textBoxSize.height}
						bgColor={colors.grey900}
						borderRadius="16px"
						space="16px"
					>
						<Text color="gray.600" size={textSize4}>
							01
						</Text>
						<Text color="singletons.white" size={textSize5}>
							{useBreakpointValue({
								base: '현재 대치동 학생들이 받고 있는\n실제 공부 컨설팅을 그대로 진행합니다.',
								lg: '현재 대치동 학생들이 받고 있는\n실제 공부 컨설팅을\n그대로 진행합니다.',
							})}
						</Text>
					</VStack>
					<Box
						w={{ base: '16px', lg: '20px' }}
						h={{ base: '16px', lg: '20px' }}
					/>
					<VStack
						px={{
							base: '20px',
							lg: '24px',
						}}
						py={{
							base: '24px',
							lg: '32px',
						}}
						w={textBoxSize.width}
						h={textBoxSize.height}
						bgColor={colors.grey900}
						borderRadius="16px"
						space="16px"
					>
						<Text color="gray.600" size={textSize4}>
							02
						</Text>
						<Text color="singletons.white" size={textSize5}>
							{useBreakpointValue({
								base: '학부모님과 자녀가 대립할 필요 없이, \n공부 컨설턴트가 동기부여를 통해\n아이에게 공부의 필요성을 깨우쳐 줍니다.',
								lg: '학부모님과 자녀가 대립할 필요 없이, \n전문 컨설턴트가 동기부여를 통해\n아이에게 공부의 필요성을\n깨우쳐 줍니다.',
							})}
						</Text>
					</VStack>
					<Box
						w={{ base: '16px', lg: '20px' }}
						h={{ base: '16px', lg: '20px' }}
					/>
					<VStack
						px={{
							base: '20px',
							lg: '24px',
						}}
						py={{
							base: '24px',
							lg: '32px',
						}}
						w={textBoxSize.width}
						h={{ base: '257px', lg: '324px' }}
						bgColor={colors.grey900}
						borderRadius="16px"
						space="16px"
					>
						<Text color="gray.600" size={textSize4}>
							03
						</Text>
						<Text color="singletons.white" size={textSize5}>
							{useBreakpointValue({
								base: '자녀 공부에 대한 모든 것에 대해\n명쾌한 해답을 내려드립니다.',
								lg: '자녀 공부에 대한 모든 것에 대해\n명쾌한 해답을 내려드립니다.',
							})}
						</Text>
						<Text size="p_s/500" color={colors.grey400}>
							{'\u2022'} 미래 성적과 대학 예측{'\n'}
							{'\u2022'} 내 성향에 맞는 학원과 공부법{'\n'}
							{'\u2022'} 이대로 하면 상위 1%! 과목별 공부법{'\n'}
							{'\u2022'} 공부 다리 찢기 PLAN{'\n'}
							{'\u2022'} 추천 학습법
						</Text>
					</VStack>
					<Box
						w={{ base: '16px', lg: '20px' }}
						h={{ base: '16px', lg: '20px' }}
					/>
				</Stack>
			</VStack>
		</Box>
	)
}

export default IntroSection3
